export const ROI_COST_SOURCES = [
  'facebook',
  'facebook_vo',
  'ads',
  'ads_30',
  'apple_ads',
  'tiktok',
  'tiktok_30',
  'unity_ads',
  'unity_ads_30',
]
